import React from "react";

export const Contact = () => {
  return (
    <div className="contact-content text-center">
      <h1>CONTACT</h1>

      <p>
        Wahyu Mahendra (@iw.wm) is a photographer based in Bali, Indonesia.
        <br />
        Wahyu's lifestyle as a travel and photographer makes him an attractive
        and exciting options for brands looking for adventure, travel and
        lifestyle content! His ability to craft a story in a creative and
        compelling way is what makes him an asset to any brand.
      </p>
      <form>
        <div className="contact-form">
          <div className="contact-form-names">
            <div className="contact-form-input-container">
              <label htmlFor="full-name">Full Name *</label>
              <input
                name="full-name"
                type="text"
                placeholder="Enter your full name..."
                required
              />
            </div>
            <div className="contact-form-input-container">
              <label htmlFor="e-mail">Email *</label>
              <input
                name="e-mail"
                type="text"
                placeholder="Enter your email..."
                required
              />
            </div>
          </div>
          <div className="contact-form-input-container width-full">
            <label htmlFor="subject">Subject *</label>
            <input
              name="subject"
              type="text"
              placeholder="Enter your subject..."
              required
            />
          </div>
          <div className="contact-form-input-container width-full">
            <label htmlFor="message">Message *</label>
            <textarea
              name="message"
              placeholder="Enter your Message..."
              required
            />
          </div>
          <input type="submit" className="contact-form-submit" value="SEND" />
        </div>
      </form>
    </div>
  );
};

export default Contact;
